// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/e-surance-membership-schema',
  type: 'object',
  required: ['isReEntry', 'entryDate', 'businessPostalCode', 'businessCity', 'payrollCategoryKey', 'payrollCategoryName'],
  properties: {
    isReEntry: {
      type: 'boolean',
    },
    entryDate: {
      type: 'string',
      format: 'date-time',
    },
    businessPostalCode: {
      type: 'string',
      minLength: 1,
    },
    businessPostalCodeAddition: {
      type: 'string',
      nullable: true,
    },
    businessCity: {
      type: 'string',
      minLength: 1,
    },
    payrollCategoryKey: {
      type: 'integer',
    },
    payrollCategoryName: {
      type: 'string',
      minLength: 1,
    },
    socialInsuranceTypeId: {
      type: 'string',
      format: 'uuid',
      nullable: true,
    },
    socialInsuranceTypeName: {
      type: 'string',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
